export const PROJ_COLORS = { target: "#2563eb", real: "#059669", projection: "#f97316" };
const fmt = (v) => Number(v || 0).toLocaleString("es-DO");
const pctColor = (p) => (p == null ? "#64748b" : p >= 95 ? "#059669" : p >= 70 ? "#d97706" : "#dc2626");

export function ClosingRows({ closing }) {
  if (closing.pending) {
    return (
      <div className="text-[12px] font-bold text-gray-500" data-testid="projection-closing-pending">
        Mes cerrado · la facturación de este mes aún no se ha cargado.
      </div>
    );
  }
  return (
    <div data-testid="projection-closing-rows"
         title="Ventas facturadas del sistema (Nuevos + Seminuevos, sin Yamaha) vs objetivo del mes">
      <div className="flex items-center justify-between text-[10px] font-extrabold uppercase tracking-wider text-gray-400 mb-1">
        <span>Facturado vs objetivo</span>
        <span className="flex gap-3"><span style={{ color: PROJ_COLORS.real }}>Fact.</span><span style={{ color: PROJ_COLORS.target }}>Obj.</span><span>%</span></span>
      </div>
      <div className="space-y-1 max-h-56 overflow-y-auto pr-1">
        {closing.rows.map((r) => (
          <div key={r.name} className="flex items-center justify-between text-[14px] font-semibold"
               data-testid={`projection-closing-row-${r.name}`}>
            <span className="truncate text-gray-600" style={{ maxWidth: 130 }}>{r.name}</span>
            <span className="flex items-center gap-2" style={{ fontVariantNumeric: "tabular-nums" }}>
              <span style={{ color: PROJ_COLORS.real, fontWeight: 800 }}>{fmt(r.cierre)}</span>
              <span style={{ color: PROJ_COLORS.target, fontSize: 12, fontWeight: 700 }}>/ {fmt(r.target)}</span>
              <span style={{ color: pctColor(r.pct_of_target), fontSize: 12, fontWeight: 800, minWidth: 40, textAlign: "right" }}>
                {r.pct_of_target == null ? "s/obj" : `${r.pct_of_target}%`}
              </span>
            </span>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between text-[12px] font-extrabold pt-1.5 mt-1.5 border-t border-gray-100"
           data-testid="projection-closing-total">
        <span className="text-gray-600">Total facturado</span>
        <span>
          <span style={{ color: PROJ_COLORS.real }}>{fmt(closing.cierre)}</span>{" "}
          <span style={{ color: PROJ_COLORS.target }}>/ {fmt(closing.target)}</span>{" · "}
          <span style={{ color: pctColor(closing.pct_of_target) }}>{closing.pct_of_target ?? 0}%</span>
        </span>
      </div>
      <div className="text-[11px] font-semibold text-gray-400 mt-1 leading-snug" data-testid="projection-closing-reconcile">
        Mismas sucursales que el funnel: {fmt(closing.cierre)} unidades = {fmt(closing.con_objetivo)} con objetivo
        {(closing.sin_objetivo || []).length > 0 && (
          <> + {fmt(closing.cierre - closing.con_objetivo)} sin objetivo en el Excel ({closing.sin_objetivo.map((x) => `${x.name} ${fmt(x.n)}`).join(", ")})</>
        )}
      </div>
    </div>
  );
}
